import { QueryParamsForAssignRiders } from '@rideiq/organizers/types';
import { useBulkRiderMutations } from '@rideiq/riders/hooks/useBulkRiderMutations';
import { useToastStore } from '@rideiq/shared/stores/toastStore';

import { useBulkRiderStatusToast } from './useBulkRiderStatusToast';

interface UseBulkDeactivateRidersOptions {
  selectedRiderIds: number[];
  isAllFilteredSelected: boolean;
  totalCount: number;
  queryParams: QueryParamsForAssignRiders;
  onSuccess: () => void;
}

export const useBulkDeactivateRiders = ({
  selectedRiderIds,
  isAllFilteredSelected,
  totalCount,
  queryParams,
  onSuccess,
}: UseBulkDeactivateRidersOptions) => {
  const { addToast } = useToastStore();
  const { deactivateRiders } = useBulkRiderMutations();
  const { showStatusResultsToast } = useBulkRiderStatusToast();

  const riderCount = isAllFilteredSelected ? totalCount : selectedRiderIds.length;
  const riderLabel = riderCount === 1 ? 'Rider' : 'Riders';

  const submit = async (reasonKey: string) => {
    const response = await deactivateRiders({
      passengerIds: isAllFilteredSelected ? 'all' : selectedRiderIds,
      riderCount,
      queryParams,
      reasonKey,
    });

    if (response.type === 'error') {
      addToast({
        severity: 'error',
        message:
          response.error.errors.filter((message) => message.trim()).join(' ') ||
          'Failed to deactivate riders. Please try again.',
      });

      return;
    }

    showStatusResultsToast(response.data.results, 'deactivate');
    onSuccess();
  };

  return { submit, riderCount, riderLabel };
};
